import { CapoPlugin } from "/home/circleci/wineaccess/nuxt-app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];